import { realApi } from './api';

// Licencias y correos de los jugadores con club en la temporada. Datos
// personales: solo ADMIN/COMITE (el backend responde 403 al resto).
export const getLicencias = (temporadaId) =>
  realApi.get(`/temporadas/${encodeURIComponent(temporadaId)}/licencias`).then((r) => r.datos);

// Alta o corrección de la licencia de un jugador esa temporada. El jugador
// tiene que tener club (409 JUGADOR_SIN_CLUB si no); `fechaExpiracion` es
// 'YYYY-MM-DD'.
export const guardarLicencia = (temporadaId, jugadorId, { numeroLicencia, fechaExpiracion }) =>
  realApi.put(`/temporadas/${encodeURIComponent(temporadaId)}/licencias/${jugadorId}`, { numeroLicencia, fechaExpiracion });

export const borrarLicencia = (temporadaId, jugadorId) =>
  realApi.delete(`/temporadas/${encodeURIComponent(temporadaId)}/licencias/${jugadorId}`);
